import React, { Fragment, useContext, useState } from "react";
import Logo from "../components/Logo";
import CountryContext, {
  LANGUAGE_KEY,
  SELECTED_COUNTRY_KEY,
} from "../CountryContext";
import AuthenticationService from "../services/AuthenticationService";
import Button from "../ui-components/Button";
import Footer from "../components/Footer";
import { FormattedMessage } from "react-intl";
import { useHistory } from "react-router-dom";
import { BrandingBg } from "../components/Brandingbg";

const PublicHome = (props) => {
  const { country } = useContext(CountryContext);
  const history = useHistory();

  const [toPath] = useState(
    props.location.state ? props.location.state.from.slice(3) : "/home"
  );

  return (
    <div>
      <div className="w-full bg-white sticky top-0 py-4">
        <div className="flex flex-wrap justify-between items-center container mx-auto px-4 gap-6">
          <div>
            <Logo business="kerakoll" padding="" height="h-auto md:py-4" />
          </div>
          <div className="flex gap-4">
            {!AuthenticationService.isUserAuthenticated() ? (
              <Fragment>
                <span>
                  <Button
                    onClick={() => {
                      history.push({
                        pathname: `/${country.code}/login`,
                        state: { toPath: toPath },
                      });
                    }}
                    styleType="empty"
                    className="m-1"
                  >
                    LOGIN
                  </Button>
                </span>
                {country.code !== "es" && (
                  <a href={`/${country.code}/signup`}>
                    <Button className="m-1">SIGNUP</Button>
                  </a>
                )}
              </Fragment>
            ) : (
              <a href={`/${country.code}/home`}>
                <Button>DASHBOARD</Button>
              </a>
            )}
          </div>
        </div>
      </div>
      <div
        style={{
          minHeight: "calc(100vh - 186px)",
        }}
        className="flex items-stretch"
      >
        <div className="w-full">
          <BrandingBg bgOpacity="60">
            <div className="text-white container mx-auto pt-32 px-4">
              <h1 className="text-5xl max-w-4xl mb-4 lg:mb-6">
                Building Platform
              </h1>
              <p className="text-base max-w-4xl">
                <FormattedMessage id={"landing_page_description"} />
              </p>
              <div className="mt-6">
                <Button
                  onClick={() => {
                    localStorage.removeItem(SELECTED_COUNTRY_KEY);
                    localStorage.removeItem(LANGUAGE_KEY);
                    window.location = "/";
                  }}
                  styleType="emptyWhite"
                  className="text-xs mt-10"
                >
                  Change country{" "}
                  <span aria-hidden="true" className="ml-2">
                    {" "}
                    &rarr;
                  </span>
                </Button>
              </div>
            </div>
          </BrandingBg>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PublicHome;
